// Styles
import { atQuery } from '../../scripts/components/mediaQueries';
import { loadMinicart, openMinicart } from '../../scripts/components/minicart';
import { headerHeight } from '../../scripts/helpers';
import { showBackdrop, hideBackdrop } from '../../scripts/components/backdrop';
import './template-product.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateProduct = (context) => {
  const templateProductSection = context.closest('.shopify-section');
  if (!templateProductSection) return;

  const initProductGallery = (gallery) => {
    if (gallery.classList.contains('product-gallery--thumbnails')) {
      const swiperGallery = new Swiper(
        gallery.querySelector('.product-gallery__container'),
      );
      gallery
        .querySelectorAll('.product-gallery__grid-thumbnail')
        .forEach((thumbnail) => {
          const thumbnailIndex = thumbnail.dataset.thumbnailIndex;
          thumbnail.addEventListener('click', () => {
            swiperGallery.slideTo(thumbnailIndex);
          });
        });
    } else if (gallery.classList.contains('product-gallery--scroll')) {
      const thumbnailsContainer = gallery.querySelector('.swiper-wrapper');
      const slideHeight = gallery.querySelector('.swiper-slide').clientHeight;
      gallery
        .querySelectorAll('.product-gallery__scroll-thumbnail')
        .forEach((thumbnail) => {
          const thumbnailIndex = parseInt(thumbnail.dataset.thumbnailIndex);
          thumbnail.addEventListener('click', () => {
            thumbnailsContainer.scrollTop = slideHeight * thumbnailIndex;
          });
        });
    }
  };

  const productsGalleries =
    templateProductSection.querySelectorAll('.product-gallery');

  productsGalleries.forEach((productsGallery) => {
    if (templateProductSection.classList.contains('maxheight')) {
      productsGallery.style.maxHeight = `calc(100vh - ${headerHeight()}px)`;
    }
    ['resize', 'orientationchange'].forEach((evt) => {
      window.addEventListener(evt, () => {
        if (templateProductSection.classList.contains('maxheight')) {
          productsGallery.style.maxHeight = `calc(100vh - ${headerHeight()}px)`;
        }
      });
    });

let direction = productsGallery.dataset.pagination == 'bottom' ? 'horizontal' : 'vertical';
if (productsGallery.classList.contains('product-gallery--carousel')) {
  direction = 'horizontal';
}

    new Swiper(productsGallery.querySelector('.product-gallery__container'), {
      loop: productsGallery.classList.contains('product-gallery--scroll')
        ? false
        : true,
      direction: direction,
      pagination: {
        el: productsGallery.querySelector('.product-gallery__pagination'),
        type: productsGallery.dataset.paginationType,
        clickable: true,
        renderCustom: function (swiper, current, total) {
          return `<span>${current} ${productsGallery.dataset.paginationSeparator} ${total}</span>`;
        },
      },
      navigation: {
        prevEl: productsGallery.querySelector('.product-gallery__arrow--left'),
        nextEl: productsGallery.querySelector('.product-gallery__arrow--right'),
      },
      breakpoints: {
        1025: {
          allowSlidePrev: productsGallery.classList.contains(
            'product-gallery--scroll',
          )
            ? false
            : true,
          allowSlideNext: productsGallery.classList.contains(
            'product-gallery--scroll',
          )
            ? false
            : true,
        },
      },
    });

    initProductGallery(productsGallery);
  });

  const productMeta = templateProductSection.querySelector('.product__meta');
  if (productMeta.classList.contains('product__meta--fixed')) {
    const fixedToggle = productMeta.querySelector(
      '.product__meta__fixed-toggle',
    );
    const fixedModeToggle = productMeta.querySelectorAll(
      '.fixed-mode-slide-toggle',
    );
    if (fixedToggle && fixedModeToggle.length > 0) {
      fixedToggle.addEventListener('click', () => {
        productMeta.classList.add('is-animating');
        if (productMeta.classList.contains('open')) {
          $(fixedModeToggle).slideUp(500, function () {
            this.style.display = '';
            productMeta.classList.remove('open');
            productMeta.classList.remove('is-animating');
            document.querySelector('html').style.overflowY = '';
          });
        } else {
          document.querySelector('html').style.overflowY = 'hidden';
          $(fixedModeToggle).slideDown(500, function () {
            this.style.display = '';
            productMeta.classList.add('open');
            productMeta.classList.remove('is-animating');
          });
        }
      });
    }

    atQuery('min', 'lg', () => {
      document.querySelector('html').style.overflowY = '';
      productMeta.classList.remove('open');
      productMeta.classList.remove('is-animating');
    });
  }

  const productForm = templateProductSection.querySelector('.product__form');
  if (
    typeof ShopifyAPI !== 'undefined' &&
    typeof ShopifyAPI.addItemFromForm !== 'undefined'
  ) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      ShopifyAPI.addItemFromForm(
        productForm,
        async () => {
          await loadMinicart();
          openMinicart();
        },
        (XMLHttpRequest, textStatus) => {
          const errorWrapper = productForm.querySelector(
            '.product__form__error',
          );
          if (errorWrapper && XMLHttpRequest?.responseJSON?.description) {
            errorWrapper.innerText = XMLHttpRequest.responseJSON.description;
            setTimeout(() => {
              errorWrapper.innerText = '';
            }, 5000);
          }
        },
      );
    });
  }
  productForm
    .querySelectorAll('.product__form__option__toggle')
    .forEach((toggle) => {
      const fieldset = toggle.closest('fieldset');
      if (!fieldset) return;
      toggle.addEventListener('click', () => {
        if (toggle.getAttribute('checked')) return;
        const checkedLabels = fieldset.querySelectorAll('label[checked]');
        checkedLabels.forEach((label) => {
          label.removeAttribute('checked');
        });
        toggle.setAttribute('checked', '');
      });
    });

  const colorsAccordion = productForm.querySelector(
    '.product__form__colors-accordion',
  );
  if (colorsAccordion) {
    const accordionHeader = colorsAccordion.querySelector(
      '.product__form__colors-accordion__header',
    );
    const accordionContent = colorsAccordion.querySelector(
      '.product__form__colors-accordion__content',
    );
    if (accordionHeader && accordionContent) {
      var isMoving = false;
      accordionHeader.addEventListener('click', function () {
        if (isMoving) return;
        isMoving = true;
        if (colorsAccordion.getAttribute('open')) {
          $(accordionContent).slideUp(350, function () {
            isMoving = false;
            colorsAccordion.removeAttribute('open');
            this.style.display = '';
          });
        } else {
          $(accordionContent).slideDown(350, function () {
            isMoving = false;
            colorsAccordion.setAttribute('open', 'true');
            this.style.display = '';
          });
        }
      });

      const colorToggles = accordionContent.querySelectorAll('.color-label');
      if (colorToggles.length > 0) {
        colorToggles.forEach((toggle) => {
          const colorValue = toggle.closest('.color-label').dataset.colorValue;
          const summaryColor = accordionHeader.querySelector('.color-label');
          if (colorValue && summaryColor) {
            toggle.addEventListener('click', () => {
              summaryColor.innerText = colorValue;
              summaryColor.dataset.colorValue = colorValue;
            });
          }
        });
      }
    }
  }

  const handleQtyButtons = () => {
    const qtySelectorInput = document.querySelector('.js-qty .js-qty__num');
    const qtySelectorBtnMinus = document.querySelector(
      '.js-qty .js-qty__adjust--minus',
    );
    const qtySelectorBtnPlus = document.querySelector(
      '.js-qty .js-qty__adjust--plus',
    );
    if (
      !qtySelectorInput ||
      !qtySelectorBtnMinus ||
      !qtySelectorBtnPlus ||
      !qtySelectorInput.dataset.stock
    )
      return;

    if (
      parseInt(qtySelectorInput.value) >=
      parseInt(qtySelectorInput.dataset.stock)
    ) {
      qtySelectorInput.value = qtySelectorInput.dataset.stock;
      qtySelectorBtnPlus.setAttribute('disabled', '');
    } else {
      qtySelectorBtnPlus.removeAttribute('disabled');
    }

    if (parseInt(qtySelectorInput.value) <= 1) {
      qtySelectorBtnMinus.setAttribute('disabled', '');
    } else {
      qtySelectorBtnMinus.removeAttribute('disabled');
    }
  };

  const selectedOption = productForm.querySelector(
    `select[name="id"] option[checked][data-stock]`,
  );
  const qtySelectorInput = document.querySelector('.js-qty .js-qty__num');
  const qtySelectorBtnMinus = document.querySelector(
    '.js-qty .js-qty__adjust--minus',
  );
  const qtySelectorBtnPlus = document.querySelector(
    '.js-qty .js-qty__adjust--plus',
  );
  if (qtySelectorInput && qtySelectorBtnMinus && qtySelectorBtnPlus) {
    if (selectedOption) {
      qtySelectorInput.setAttribute('data-stock', selectedOption.dataset.stock);
    } else {
      qtySelectorInput.setAttribute('data-stock', 1);
    }

    [qtySelectorBtnMinus, qtySelectorBtnPlus].forEach((el) => {
      el.addEventListener('click', () => {
        handleQtyButtons();
      });
    });

    handleQtyButtons();
  }

  const soldOutTag = productMeta.querySelector('.product__meta__tag--sold-out');
  const saleTag = productMeta.querySelector('.product__meta__tag--sale');
  const generalTag = productMeta.querySelector(
    '.product__meta__tag:not(.product__meta__tag--sale):not(.product__meta__tag--sold-out)',
  );
  $(context).on('variantChange', (e) => {
    if (!e || !e.variant) return;

    if (!e.variant.available && soldOutTag) {
      soldOutTag.classList.add('active');
      saleTag.classList.remove('active');
      if (generalTag) {
        generalTag.classList.remove('active');
      }
    } else if (
      e.variant.price &&
      e.variant.compare_at_price &&
      e.variant.price != e.variant.compare_at_price &&
      saleTag
    ) {
      soldOutTag.classList.remove('active');
      saleTag.classList.add('active');
      if (generalTag) {
        generalTag.classList.remove('active');
      }
    } else if (generalTag) {
      soldOutTag.classList.remove('active');
      saleTag.classList.remove('active');
      generalTag.classList.add('active');
    }

    const selectedOption = productForm.querySelector(
      `select[name="id"] option[value="${e.variant.id}"][data-stock]`,
    );
    if (!selectedOption) return;

    if (qtySelectorInput) {
      qtySelectorInput.setAttribute('data-stock', selectedOption.dataset.stock);
    }
    handleQtyButtons();
  });

  $('.product-template').on('variantSKUChange', function (e) {
    const active = this.querySelector('.product-gallery[active]');
    if (active) {
      active.removeAttribute('active');
    }

    const galleries = this.querySelectorAll('.product-gallery');
    for (let i = 0; i < galleries.length; i++) {
      const gallery = galleries[i];
      if (gallery.getAttribute('data-sku') == e.variant.sku) {
        gallery.setAttribute('active', true);
        initProductGallery(gallery);
      }
    }
  });

  const productDrawers = templateProductSection.querySelectorAll('.product__drawer');  
  const productDrawersTriggers = templateProductSection.querySelectorAll('.product__drawer__trigger'); 
  if(productDrawers && productDrawersTriggers) {
    productDrawers.forEach(drawer => {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'class') {
            const isOpen = drawer.classList.contains('open');
            if (isOpen) { // at opening
              showBackdrop(); 
            } else {
              hideBackdrop(); // at closing
            }
          }
        });
      });
      observer.observe(drawer, { attributes: true });

      const closeButton = drawer.querySelector('.product__drawer__close');
      closeButton.addEventListener('click', () => {
        drawer.classList.remove('open');
      });
    });

    productDrawersTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        productDrawers.forEach(drawer => {
          if (trigger.getAttribute('data-content') === drawer.getAttribute('data-content')) {
            drawer.classList.add('open');
          }
        });
      });
    });
  }
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
    window.dAgency.initTemplateProduct(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-template'), (el) => {
      window.dAgency.initTemplateProduct(el);
    });
  });
}
